import dragagble from "$mixins/draggable";

export default {
  mixins: [dragagble],
  props: {
    uid: String,
    opener: Object,
    order: Number,
  },
  computed: {
    zIndex() {
      return 10000 + this.order;
    },
  },
  methods: {
    close() {
      this.$emit("close", this.uid);
    },
  },
  mounted() {
    this.$el.addEventListener("mousedown", () => {
      this.$emit("mousedown");
    });
    if (this.opener) this.opener.$on("hook:beforeDestroy", this.close);
  },
};
